export const toPixels = (value: string | number): string => `${value}px`

const formats = {
  euro: {
    locale: 'de-DE',
    currency: 'EUR',
  },
  usd: {
    locale: 'en-US',
    currency: 'USD',
  },
}

export const formatMoney = (
  number: number,
  currency: 'euro' | 'usd' = 'euro',
  options?: Intl.NumberFormatOptions,
): string => {
  return new Intl.NumberFormat(formats[currency].locale, {
    style: 'currency',
    currency: formats[currency].currency,
    ...options,
  })
    .format(number)
    .toString()
    .split(' ')
    .reverse()
    .join(' ')
}

// changes number to a compact money format e.g. 5000000 to "EUR 5 Mio."
export const compactMoney = (
  number: number,
  currency: 'euro' | 'usd' = 'euro',
  options?: Intl.NumberFormatOptions,
): string => {
  const result = new Intl.NumberFormat(formats[currency].locale, {
    style: 'currency',
    currency: formats[currency].currency,
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 0,
    ...options,
  })
    .format(number)
    .split(' ')

  return [...result.slice(-1), ...result.slice(0, -1)].join(' ')
}

export const timestampToDateString = (timestamp: number): string => {
  if (!timestamp && timestamp !== 0) return ''
  const d = new Date(timestamp)
  const parts = [d.getFullYear(), d.getMonth() + 1, d.getDate()].map((n) =>
    n < 10 ? `0${n}` : `${n}`,
  )
  return parts.join('-')
}

export const isIsoDateString = (value: string): boolean => {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/

  return isoDateRegex.test(value) && !isNaN(Date.parse(value))
}

export const ddMMyyyy = (dateValue: number | string | Date): string => {
  if (
    typeof dateValue === 'string' &&
    (!dateValue || !isIsoDateString(dateValue))
  )
    return ''
  if (typeof dateValue === 'number' && !dateValue && dateValue !== 0) return ''
  const d = new Date(dateValue)
  const parts = [d.getDate(), d.getMonth() + 1, d.getFullYear()].map((n) =>
    n < 10 ? `0${n}` : `${n}`,
  )
  return parts.join('.')
}

// generates a price placeholder generally used across the app
export const generatePricePlaceholder = (
  currency: 'euro' | 'usd' = 'euro',
): string => {
  const formatter = new Intl.NumberFormat(formats[currency].locale, {
    style: 'currency',
    currency: formats[currency].currency,
    currencyDisplay: 'symbol',
  })

  return formatter.format(12.34).replace(/\d/g, '--')
}
